/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * Used to house Engineering/Mfg. related details
 */
export var CustomEngStatus;
(function (CustomEngStatus) {
    CustomEngStatus["TO_BE_ENGINEERED"] = "To Be Engineered";
    CustomEngStatus["ENGINEERING_COMPLETE"] = "Engineering Complete";
    CustomEngStatus["ECO_PENDING"] = "ECO Pending";
})(CustomEngStatus || (CustomEngStatus = {}));
